export const DATE_MORE_THAN = '>'
export const DATE_LESS_THAN = '<'
export const DATE_EQUAL = '=='
export const DATE_AFTER = '>='
export const DATE_ON = '==='
export const DATE_BEFORE = '<='
export const DATE_IS_UNKNOWN = 'unknown' // implement
export const DATE_ANY = 'any' // implement

export const dateOperators = Object.freeze({
    // greaterThan: {
    //     key: DATE_MORE_THAN,
    //     label: 'More than',
    //     json: {
    //         getLogic: (a, b) => ({
    //             [DATE_MORE_THAN]: [a, b]
    //         }),
    //         getData: () => null
    //     }
    // },
    // lessThan: { // technically the same as 'after', you should prepare relative data before passing into getLogic function
    //     key: [DATE_MORE_THAN],
    //     label: 'Less than',
    //     json: {
    //         getLogic: (a, b) => ({
    //             [DATE_LESS_THAN]: [a, b]
    //         }),
    //         getData: () => null
    //     }
    // },
    // equal: {
    //     key: DATE_EQUAL,
    //     label: 'Exactly',
    //     json: {
    //         getLogic: (a, b) => ({
    //             [DATE_EQUAL]: [a, b]
    //         }),
    //         getData: () => null
    //     }
    // },
    before: {
        key: DATE_BEFORE,
        label: 'Before',
        json: {
            getLogic: (a, b) => ({
                [DATE_BEFORE]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    on: {
        key: DATE_ON,
        label: 'On',
        json: {
            getLogic: (a, b) => ({
                [DATE_ON]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    after: {
        key: DATE_AFTER,
        label: 'After',
        json: {
            getLogic: (a, b) => ({
                [DATE_AFTER]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    unknown: {
        key: DATE_IS_UNKNOWN,
        label: 'Is unknown',
        json: {
            getLogic: (a, b) => ({
                [DATE_IS_UNKNOWN]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    any: {
        key: DATE_ANY,
        label: 'Has any value',
        json: {
            getLogic: (a, b) => ({
                [DATE_ANY]: [{'var': a}, b]
            }),
            getData: () => null
        }
    }
})

export const dateOperatorsList = Object.freeze(Object.values(dateOperators))
